import './index.css';
import 'antd/dist/antd.min.css';

import { createRoot } from 'react-dom/client';

import { App } from './App';
import { GTM_ID } from './config';
import { initGtm } from './utils/gtm';

if (GTM_ID) {
  initGtm(GTM_ID);
}

const container = document.getElementById('root')!;
createRoot(container).render(<App />);
